<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>用户登录历史</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input placeholder="请输入用户ID" clearable v-model="userId" size="mini">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入登录IP" clearable v-model="ip" size="mini">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入设备ID" clearable v-model="phoneId" size="mini">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select size="mini" v-model="type" placeholder="请筛选设备类型">
          <el-option value="" label="全部类型">全部类型</el-option>
          <el-option v-for="item in loginTypesOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select size="mini" v-model="userType" placeholder="请选择用户类型">
          <el-option value="" label="全部用户"></el-option>
          <el-option
            v-for="item in userTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker v-model="value1" type="daterange" align="right" format="yyyy-MM-dd" value-format="timestamp"
          unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
          :picker-options="pickerOptions" size="mini">
        </el-date-picker>
        <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
        <el-button size="mini" @click="exportExcel">导出</el-button>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions } from "vuex";
import { PAGINATION } from "./constants";
import { transformTime } from "@/utils/formatTime";
import api from "./api";
export default {
  name: "userLoginLog",
  components: {
    UserList,
  },
  data() {
    return {
      userId: "",
      ip: "",
      phoneId: "",
      type: "",
      userType: "",
      // value1: [
      //   moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     'YYYY-MM-DD'
      //   ),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      value1: "",
      loginTypesOption: [
        { value: "WEB", label: "WEB" },
        { value: "IPHONE", label: "IPHONE" },
        { value: "ANDROID", label: "ANDROID" },
      ],
      userTypeOptions: [
        { value: 2, label: "普通用户" },
        { value: 1, label: "模拟盘用户" },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("userLoginLog", ["queryType", "queryTypeList", "pagination"]),
  },
  methods: {
    ...mapActions("userLoginLog", ["list"]),
    buildQuery(data = {}) {
      return {
        userId: this.userId,
        ip: this.ip,
        phoneId: this.phoneId,
        type: this.type,
        userType: this.userType,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1 ? this.value1[0] : "",
          endTimeNUmber: this.value1 ? this.value1[1] : "",
        }),
        ...this.pagination,
        ...data,
      };
    },
    refreshList(data = {}) {
      this.list(this.buildQuery(data));
    },

    handleSearch() {
      this.list(this.buildQuery(PAGINATION));
    },
    exportExcel() {
      const { page, size, ...query } = this.buildQuery();
      api.exportUserLoginLog(query).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.download = "用户登录历史";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() { },
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>

<style lang="less" scoped></style>
